import React, { createContext, useContext, useMemo, type PropsWithChildren } from 'react';
import type { Props } from '../types.tsx';

const initialProps: Props = {
	integrationType: '',
	productId: 'jira',
	subProductId: 'jira-platform',
	shareTitle: '',
	shareContentType: '',
	objectAri: '',
};

export const EntrypointPropsContext = createContext<Props>(initialProps);

export const EntrypointPropsProvider = ({
	isAutoOpenDialog,
	integrationType,
	triggerButtonAppearance,
	triggerButtonStyle,
	renderCustomTriggerButton,
	testId,
	productId,
	subProductId,
	shareLink,
	shareTitle,
	shareContentType,
	shareFormTitle,
	objectAri,
	shareIntegrations,
	additionalTabs,
	builtInTabContentWidth,
	integrationMode,
	legacyShareClientConfig,
	copyTooltipText,
	shareShortcutTriggerCount,
	prevShareShortcutTriggerCount,
	onDialogClose,
	onTriggerButtonClick,
	shareFormHelperMessage,
	shareFieldsFooter,
	poSpotlightShareButtonId,
	customHeader,
	onSubmit,
	children,
}: PropsWithChildren<Props>): React.JSX.Element => {
	const value = useMemo(
		() => ({
			isAutoOpenDialog,
			integrationType,
			triggerButtonAppearance,
			triggerButtonStyle,
			renderCustomTriggerButton,
			testId,
			productId,
			subProductId,
			shareLink,
			shareTitle,
			shareContentType,
			shareFormTitle,
			objectAri,
			shareIntegrations,
			additionalTabs,
			builtInTabContentWidth,
			integrationMode,
			legacyShareClientConfig,
			copyTooltipText,
			shareShortcutTriggerCount,
			prevShareShortcutTriggerCount,
			onDialogClose,
			onTriggerButtonClick,
			shareFormHelperMessage,
			shareFieldsFooter,
			poSpotlightShareButtonId,
			customHeader,
			onSubmit,
		}),
		[
			isAutoOpenDialog,
			integrationType,
			triggerButtonAppearance,
			triggerButtonStyle,
			renderCustomTriggerButton,
			testId,
			productId,
			subProductId,
			shareLink,
			shareTitle,
			shareContentType,
			shareFormTitle,
			objectAri,
			shareIntegrations,
			additionalTabs,
			builtInTabContentWidth,
			integrationMode,
			legacyShareClientConfig,
			copyTooltipText,
			shareShortcutTriggerCount,
			prevShareShortcutTriggerCount,
			onDialogClose,
			onTriggerButtonClick,
			shareFormHelperMessage,
			shareFieldsFooter,
			poSpotlightShareButtonId,
			customHeader,
			onSubmit,
		],
	);

	return (
		<EntrypointPropsContext.Provider value={value}>{children}</EntrypointPropsContext.Provider>
	);
};

export const useEntrypointProps = () => useContext(EntrypointPropsContext);
